import { LINKS } from '@fans-fund-me/shared-comm-react-cosmos/fans-fund-me/links';
import { useAuth } from '@fans-fund-me/shared-common-esm-authentication';
import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router';

type RequireAuthProps = {
  children: React.ReactNode;
};

function RequireAuth({ children }: RequireAuthProps) {
  const auth = useAuth();
  const location = useLocation();
  const [loggedOut, setLoggedOut] = useState(false);

  useEffect(() => {
    if (auth.hasInitialised && !auth.token) {
      auth
        .logout()
        .then(() => {
          setLoggedOut(true);
        })
        .catch(() => {
          setLoggedOut(true);
        });
    }
  }, [auth]);

  if (loggedOut) {
    return <Navigate to={LINKS.LOGIN} state={{ from: location }} replace />;
  }

  return <>{children}</>;
}

export default RequireAuth;
